module.exports = __webpack_public_path__ + "img/rads.f8994397.svg";